import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const EmbedIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Embed",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M26.5 4.62h-21C3.57 4.62 2 6.19 2 8.12v15.75c0 1.93 1.57 3.49 3.5 3.5h21c1.93 0 3.49-1.57 3.5-3.5V8.11c0-1.93-1.57-3.5-3.5-3.5ZM11.19 19.68a1.119 1.119 0 0 1-.79 1.91c-.31 0-.59-.13-.79-.33l-4.48-4.47c-.2-.2-.33-.48-.33-.79s.13-.59.33-.79l4.48-4.48c.2-.2.48-.33.79-.33s.59.13.79.33.33.48.33.79-.13.59-.33.79L7.5 15.98l3.69 3.69Zm4.41 3.98c-.09.53-.54.93-1.09.93h-.22c-.52-.11-.9-.56-.9-1.1 0-.07 0-.15.02-.22S16.4 8.34 16.4 8.34c.13-.48.57-.82 1.08-.82.62 0 1.12.5 1.12 1.12v.13l-2.99 14.88Zm11.27-6.86-4.48 4.47a1.119 1.119 0 0 1-1.91-.79c0-.31.13-.59.33-.79l3.73-3.73-3.73-3.68a1.119 1.119 0 0 1 .79-1.91c.31 0 .59.13.79.33l4.48 4.48c.22.2.35.49.35.82s-.14.61-.35.82Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M28.43 27.71H3.29c-1.89 0-3.43-1.54-3.43-3.43v-16c0-1.89 1.54-3.43 3.43-3.43h25.14c1.89 0 3.43 1.54 3.43 3.43v16c0 1.89-1.54 3.43-3.43 3.43M3.29 7.14c-.63 0-1.14.51-1.14 1.14v16c0 .63.51 1.14 1.14 1.14h25.14c.63 0 1.14-.51 1.14-1.14v-16c0-.63-.51-1.14-1.14-1.14z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M22.71 20.86c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l2.62-2.62-2.62-2.62c-.45-.45-.45-1.17 0-1.62s1.17-.45 1.62 0l3.43 3.43a1.16 1.16 0 0 1 0 1.62l-3.43 3.43c-.22.22-.52.33-.81.33M9 20.87c-.29 0-.58-.11-.81-.33l-3.43-3.43a1.16 1.16 0 0 1 0-1.62l3.43-3.43c.45-.45 1.17-.45 1.62 0s.45 1.17 0 1.62L7.19 16.3l2.62 2.62A1.14 1.14 0 0 1 9 20.87M14.33 23.14a1.145 1.145 0 0 1-1.11-1.44l3.05-11.39c.16-.61.79-.97 1.4-.81s.97.79.81 1.4l-3.05 11.39c-.14.51-.6.85-1.1.85"
      })]
    })
  }));
};
EmbedIcon.displayName = 'EmbedIcon';